/**
 * Readers for a block's payload. Renderers take `payload: any` and must never
 * throw on a malformed one, because a renderer that throws takes down the
 * whole slide in front of an audience. These make that the easy path.
 */

export const asArray = <T,>(value: unknown): T[] => (Array.isArray(value) ? (value as T[]) : [])

export const asText = (value: unknown) => (typeof value === 'string' ? value : '')

export const asNumber = (value: unknown) => (typeof value === 'number' && Number.isFinite(value) ? value : null)
